// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./dataTables.bootstrap4.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../vue-style-loader/lib/addStylesClient.js").default
var update = add("47e06723", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/datatables.net-bs4/css/dataTables.bootstrap4.css
// module id = 1730
// module chunks = 0